"use client";
import { Dispatch, MouseEvent, SetStateAction } from "react";
import { searchHistory } from "../../service";
import "./index.scss";
import { useTranslations } from "next-intl";
export default function HistoryListSearch({
  setIsDeleting,
  onSelect,
}: {
  setIsDeleting: Dispatch<SetStateAction<boolean>>;
  onSelect: (value: string) => void;
}) {
  const history = searchHistory.getHistory();
  const t = useTranslations("SearchModal");

  function onDelete(e: MouseEvent<HTMLDivElement>, value: string) {
    e.preventDefault();
    e.stopPropagation();
    setIsDeleting(true);
    searchHistory.deleteValue(value);
    setTimeout(() => setIsDeleting(false), 100);
  }
  function handleSelect(value: string) {
    try {
      onSelect(value);
    } catch (error) {
      console.error("Error selecting history item:", error);
    }
  }
  if (history.length == 0) return null;
  return (
    <div key={"history-block-data"} data-test="search-dropdown" className="search-dropdown">
      <p className="search-dropdown__title">{t("history")}</p>
      <div className="search-dropdown_scroll">
        {history.map((value, index) => (
          <div
            key={`${index}-history-value-local`}
            data-test="search-dropdown__item"
            className="search-dropdown__item"
            onClick={() => handleSelect(value)}
            onMouseDown={(e) => e.preventDefault()}
          >
            <svg
              className="icon search-dropdown__item-icon"
              height="21px"
              version="1.1"
              viewBox="0 0 20 21"
              width="20px"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g
                fill="#fff"
                id="Core"
                opacity="0.9"
                transform="translate(-464.000000, -254.000000)"
              >
                <g id="history" transform="translate(464.000000, 254.500000)">
                  <path
                    d={`M10.5,0 C7,0 3.9,1.9 
                    2.3,4.8 L0,2.5 L0,9 L6.5,9 L3.7,6.2 C5,3.7 7.5,2 10.5,2 C14.6,2 18,5.4 18,9.5 C18,13.6 14.6,17 10.5,17 C7.2,17 4.5,14.9 3.4,12 L1.3,12 C2.4,16 6.1,19 10.5,19 C15.8,19 20,14.7 20,9.5 C20,4.3 15.7,0 10.5,0 L10.5,0 Z M9,5 L9,10.1
                     L13.7,12.9 L14.5,11.6 L10.5,9.2 L10.5,5 L9,5 L9,5 Z`}
                    id="Shape"
                  />
                </g>
              </g>
            </svg>
            <div data-test="search-dropdown__item-text" className="search-dropdown__item-text">
              {value}
            </div>
            <div onClick={(e) => onDelete(e, value)} className="search-dropdown__item-delete">
              <svg
                className="icon search-dropdown__item-delete-ic"
                viewBox="0 0 32 32"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs></defs>
                <title />
                <g id="cross">
                  <line className="cls-1" x1="7" x2="25" y1="7" y2="25" />
                  <line className="cls-1" x1="7" x2="25" y1="25" y2="7" />
                </g>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
